import { AlertTriangle } from 'lucide-react'
import type { UnitUnavailability } from '@/types/storage'

/**
 * Why this unit is refusing stock, in the server's own words.
 *
 * `detail` is rendered verbatim rather than re-worded here. It is the same
 * string `assertPutAway` puts in its 409, so the refusal someone hits at
 * put-away and the explanation they read on this page cannot drift apart — and
 * that drift is exactly what makes a rule feel arbitrary.
 *
 * Says explicitly that existing contents are unaffected. The rule blocks
 * movement IN only, and without that sentence "not accepting stock" reads like
 * the freezer has been sealed.
 */
export function UnitAvailabilityBanner({ unavailable }: { unavailable: UnitUnavailability }) {
  if (!unavailable) return null

  const detail = unavailable.detail.charAt(0).toUpperCase() + unavailable.detail.slice(1)

  return (
    <div
      role='status'
      className='flex items-start gap-2 rounded-md border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900'
    >
      <AlertTriangle className='mt-0.5 h-4 w-4 shrink-0' aria-hidden='true' />
      <div>
        <p className='font-medium'>This unit is not accepting stock</p>
        <p className='text-amber-800'>
          {detail}. Existing contents are unaffected — they can still be picked or moved out.
        </p>
      </div>
    </div>
  )
}
